// 봇 결과(공구 사양·유사 공정)의 원본 엑셀/PDF 파일 이름을 눌러 받는 링크.
// 2026-10-10 사용자 요청: "공구 리스트에 원본 excel 파일 이름이 있는데 이걸 다운로드할 수 있게".
// 서버는 RAG 데이터 폴더 안의 xlsx/xls/xlsm/pdf 만 내준다(ChatAiController /machining-rag/source).
import React, { useState } from 'react';
import { CircularProgress, Link } from '@mui/material';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import { useSnackbar } from 'notistack';
import { downloadMachiningSource } from '../../lib/api/chatApi';

const fileNameFromHeader = (headers, fallback) => {
  const cd = headers?.['content-disposition'] || '';
  const star = cd.match(/filename\*=UTF-8''([^;]+)/i);
  if (star) {
    try {
      return decodeURIComponent(star[1]);
    } catch {
      // 그대로 fallback
    }
  }
  const plain = cd.match(/filename="?([^";]+)"?/i);
  return plain ? plain[1] : fallback;
};

const RagSourceLink = ({ path, label, sx }) => {
  const { enqueueSnackbar } = useSnackbar();
  const [busy, setBusy] = useState(false);
  if (!path) return label || null;

  const onClick = async (e) => {
    // 행을 눌러 펼치는 동작과 겹치지 않게 막는다.
    e.preventDefault();
    e.stopPropagation();
    if (busy) return;
    setBusy(true);
    try {
      const res = await downloadMachiningSource(path);
      const name = fileNameFromHeader(res.headers, label || path.split('/').pop());
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const a = document.createElement('a');
      a.href = url;
      a.download = name;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      enqueueSnackbar(
        err?.response?.status === 404 ? '원본 파일을 찾을 수 없습니다(이동·삭제됐을 수 있어요).' : '원본 파일을 받지 못했습니다.',
        { variant: 'error' },
      );
    } finally {
      setBusy(false);
    }
  };

  return (
    <Link
      component="button"
      type="button"
      onClick={onClick}
      underline="hover"
      title="원본 파일 받기"
      sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.25, fontSize: 'inherit', verticalAlign: 'baseline', ...sx }}
    >
      {label || path.split('/').pop()}
      {busy ? <CircularProgress size={10} sx={{ ml: 0.25 }} /> : <FileDownloadOutlinedIcon sx={{ fontSize: '1em' }} />}
    </Link>
  );
};

export default RagSourceLink;
